import { useFormContext } from 'react-hook-form';
import { Button, ButtonProps } from 'shared/mui/Buttons';

export type PopoverChipFilterResetButtonProps = ButtonProps & {
  onReset?: () => void;
};

export const PopoverChipFilterResetButton: React.FC<PopoverChipFilterResetButtonProps> = ({
  onReset,
  ...restProps
}) => {
  const { reset } = useFormContext();

  function onClick() {
    reset();
    if (onReset) {
      onReset();
    }
  }

  return <Button onClick={onClick} sx={{ width: '100%' }} {...restProps} />;
};
